const Illusion = require('../ability_trees/Illusion.js');
const MeleeCombat = require('../ability_trees/MeleeCombat.js');
const Movement = require('../ability_trees/Movement.js');
const StandardAbilityTree = require('../ability_trees/StandardAbilityTree.js');

const ItemGenerator = require('../../game_items/ItemGenerator.js');
const MedHelmet = require('../../game_items/equipment/helmet/MedHelmet.js');
const MedTorsoe = require('../../game_items/equipment/torsoe/MedTorsoe.js');
const MedBoots = require('../../game_items/equipment/boots/MedBoots.js');
const Staff = require('../../game_items/equipment/weapon/Staff.js');

module.exports = {
  handle: 'monk',
  getAbilityTrees: () => ([
    Illusion,
    MeleeCombat,
    Movement,
    StandardAbilityTree,
  ]),
  getBaseAttributes: () => ({
    learning: 7,
    perception: 8,
    mana: 7,
    toughness: 7,
    strength: 7,
    willpower: 7,
    dexterity: 7,
  }),
  getDefaultAIConfig: () => (['dps_close', 'interference', 'tank', 'dps_ranged', 'support']),
  getStarterEquipment: () => ({
    helmet: ItemGenerator.getRandomItem(MedHelmet, 0, 0.1, true),
    torsoe: ItemGenerator.getRandomItem(MedTorsoe, 0, 0.1, true),
    boots: ItemGenerator.getRandomItem(MedBoots, 0, 0.1, true),
    weapon: ItemGenerator.getRandomItem(Staff, 0, 0.1, true),
  }),
};
